import { useEffect } from "preact/hooks";
import { useAnalytics } from "./analyticsProvider";

import type { Page } from "./types";

export default function useTrackPageView(page: Page) {
  const { analytics, module, selectedMethod } = useAnalytics();

  useEffect(() => {
    analytics?.track("page_view", {
      page_name: page,
      module,
      method: selectedMethod && selectedMethod.toLocaleLowerCase(),
    });
  }, [analytics, module, page, selectedMethod]);
}
